<template>
  <el-row :gutter="20">
    <el-col :key="item.type" v-for="item in statuses" class="el-row" :span="8">
      <div class="grid-content bg-purple">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ item.type }}</span>
          </div>
          <Swatches @input="color => getColor(color, item.type)" v-model="item.color" ></Swatches>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Swatches } from 'vue-color';

export default {
  name: 'SiteMapConfig',
  props: {
    theme: { type: Array, default: () => [] },
  },
  mounted() {
    if (this.theme.length !== 0) {
      this.statuses = this.theme;
      this.statuses = this.statuses.sort((a, b) => a.type.localeCompare(b.type));
    }
  },
  components: { Swatches },
  data() {
    return {
      color: '#efefef',
      statuses: [
        { type: 'AUCTION', color: '#BA68C8' },
        { type: 'AVAILABLE', color: '#4CAF50' },
        { type: 'LATE', color: '#F44336' },
        { type: 'MOVING_OUT', color: '#BBDEFB' },
        { type: 'RENTED', color: '#1976D2' },
        { type: 'LIEN', color: '#E65100' },
        { type: 'PENDING', color: '#E1BEE7' },
        { type: 'PRE_LIEN', color: '#FFA000' },
        { type: 'RESERVED', color: '#7B1FA2' },
        { type: 'UNAVAILABLE', color: '#CFD8DC' },
      ],
    };
  },
  methods: {
    getColor(color, type) {
      this.statuses.forEach((status, index) => {
        if (status.type === type) {
          this.statuses[index].color = color.hex;
        }
      });
      this.$emit('update', this.statuses);
    },
  },
};
</script>
<style scoped>
.el-row {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SiteMapConfig.vue